import { Box } from '@chakra-ui/layout';
import type { MouseEventHandler } from 'react';

import { Loading } from '@revelio/core';

import { useSafeChart } from './ChartProvider';

export const ChartLoader = ({
  onClick,
}: {
  onClick?: MouseEventHandler<HTMLDivElement>;
}) => {
  const { variant } = useSafeChart();
  const capLoaderToViewport = variant === 'report';

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      {...(capLoaderToViewport ? { maxH: '100vh' } : {})}
      zIndex="2"
      backgroundColor="white"
      borderRadius="var(--chakra-radii-md)"
      onClick={onClick}
    >
      <Loading size="sm" />
    </Box>
  );
};
